export enum HexaV2ProgressColor {
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}

export enum HexaV2TextColor {
  ON_SUCCESS_SECONDARY = 'onSuccessSecondary',
  ON_WARNING_SECONDARY = 'onWarningSecondary',
  ON_ERROR_SECONDARY = 'onErrorSecondary',
  DEFAULT = 'default',
  ERROR = 'error',
}
